import { render } from "./BewertungChip.vue?vue&type=template&id=a9865152&scoped=true&ts=true"
import script from "./BewertungChip.vue?vue&type=script&lang=ts"
export * from "./BewertungChip.vue?vue&type=script&lang=ts"

import "./BewertungChip.vue?vue&type=style&index=0&id=a9865152&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9865152"]])

export default __exports__